import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import authReducer from "app/reducers/authSlice";
import configReducer from "app/reducers/configSlice";
import containersReducer from "app/reducers/containersSlice";
import devicesReducer from "app/reducers/devicesSlice";
import matchesReducer from "app/reducers/matchesSlice";
import modalReducer from "app/reducers/modalSlice";
import modesReducer from "app/reducers/modesSlice";
import playersReducer from "app/reducers/playersSlice";
import scoresReducer from "app/reducers/scoresSlice";
import sessionReducer from "app/reducers/sessionsSlice";
import slotsReducer from "app/reducers/slotsSlice";
import soundsReducer from "app/reducers/soundsSlice";
import userReducer from "app/reducers/userSlice";
import counterReducer from "features/counter/counterSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    modal: modalReducer,
    players: playersReducer,
    matches: matchesReducer,
    sounds: soundsReducer,
    containers: containersReducer,
    session: sessionReducer,
    devices: devicesReducer,
    modes: modesReducer,
    scores: scoresReducer,
    auth: authReducer,
    user: userReducer,
    slots: slotsReducer,
    config: configReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
